/*
 * File: DiagnosisModel.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 08/29/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */

import { types } from "mobx-state-tree";
import mstIsNumber from "utils/MSTIsNumber";

const dataModel = {
  umlsId: types.maybe(types.number),
  order: types.maybe(types.number),
  toggledOn: types.optional(types.boolean, true),
  diagnosis: types.maybe(types.string),
  pointer: types.maybe(types.string),
  code: types.maybe(types.string)
};
const DiagnosisModel = types
  .model("ChargeModel", dataModel)

  .actions(self => ({
    update(key, val) {
      self[key] = mstIsNumber(self, key, val);
    },
    setOrder(order) {
      self.order = order;
    }
  }));

export default DiagnosisModel;
